import { render, staticRenderFns } from "./app-driver-info.vue?vue&type=template&id=53f0674a&scoped=true&"
import script from "./app-driver-info.vue?vue&type=script&lang=js&"
export * from "./app-driver-info.vue?vue&type=script&lang=js&"
import style0 from "./app-driver-info.vue?vue&type=style&index=0&id=53f0674a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f0674a",
  null
  
)

export default component.exports